var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.24164L14.7167 6.95831C15.6495 7.89048 16.2849 9.07836 16.5424 10.3717C16.8 11.665 16.6683 13.0057 16.1638 14.2241C15.6594 15.4425 14.8049 16.484 13.7085 17.2167C12.612 17.9495 11.3229 18.3406 10.0042 18.3406C8.68547 18.3406 7.39636 17.9495 6.29994 17.2167C5.20352 16.484 4.34904 15.4425 3.84458 14.2241C3.34012 13.0057 3.20836 11.665 3.46595 10.3717C3.72353 9.07836 4.35891 7.89048 5.29169 6.95831L10 2.24164Z",
    stroke: "#454545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.f36818d383ab2424093d51f9be99bc2e.svg";
export { ForwardRef as ReactComponent };